import React, { Component } from 'react'
import {connect} from 'react-redux';
import * as actions from '../../actions'
import FancyStoneTable from './fancy_stone_table'
import { success } from '../common/toast';
import ListIcon from '../common/list-icon';

class AvailableFancyColour extends Component {

    componentDidMount() {
        this.props.getAvailableFancyColour()
    }

    addToCart = (parcelName) => {
        this.props.addToFancyColourCart(parcelName)
        .then(() => {
            success('Added to Cart')
            this.props.getAvailableFancyColour()
            this.props.getFancyColourCart()
        })
    }

    renderFancyColour = () => {
        const stones = this.props.fancyColour || [];
        return (
            <FancyStoneTable 
                data={stones}
                extraColumns={[
                    {
                        Header: 'Available',
                        accessor: 'tentativeAvailability',
                        width: 50,
                        sortable: false,
                        filterable: false,
                        resizeable: false,
                        className: 'list-photo-column',
                        Cell: ({value}) => <span data-tip={value ? 'This diamond may not be available. We will check for you once your request is placed.' : ''}><ListIcon icon={value ? 'fa-exclamation-circle' : 'fa-check-circle'} className='table-icon mediumfont'/></span>
                    },
                    {
                        Header: '',
                        id: 'cartBtn',
                        width: 50,
                        sortable: false,
                        filterable: false,
                        Cell: (row) => row.original ? (
                            <button
                                title="Add to Cart"
                                disabled={row.original.inCart}
                                className="list-button"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    this.addToCart(row.original.parcelName);
                                }}
                            >{
                                row.original.inCart ?
                                <i className='fa fa-check-circle' /> : 
                                <i className='fa fa-shopping-cart' />
                            }</button>
                        ) : null
                    }
                ]}
                hideTier={false}
                large={true}
                exporter={this.props.excelFCExport}
                tableId='availableFC'
                allowGallery={true}
            />
        )
    }

    render() {
        return (
            <div style={{width: '100%'}}>
                {this.renderFancyColour()}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        fancyColour: state.fancyColour.available
    }
}

export default connect(mapStateToProps, actions)(AvailableFancyColour)